export const FolderSettingModel = Symbol.for('FolderSettingModel');
